/**
 * L6 — SUPERADMIN_PLAN.md §6.
 *
 * Read-only view of active platform announcements broadcast from the
 * superadmin console. The backend endpoint (see
 * backend/internal/superadmin/handler.go RegisterPublic) is mounted on
 * the tenant-scoped v1 group at /v1/announcements and returns only the
 * announcements that target the current tenant (all-tenants or explicit
 * tenant/pack targeting).
 */

import { apiFetch } from '@/api/client'

export type AnnouncementSeverity = 'info' | 'warning' | 'critical'

export interface Announcement {
  id: string
  title: string
  body: string
  severity: AnnouncementSeverity
  starts_at: string
  ends_at: string | null
  is_active?: boolean
  created_at: string
  updated_at?: string
}

interface ListEnvelope<T> {
  data: T[]
}

export const announcementsApi = {
  list: () =>
    apiFetch<ListEnvelope<Announcement>>('/v1/announcements').then((r) => r.data ?? []),
}
